import { defineStore } from 'pinia';

import IKitchen from '@/models/kitchen';

import jsonApi from '@/libs/jsonapi';

const useKitchen = defineStore('kitchen', {
  actions: {
    async getAll(
      params: Partial<{
        filters: Partial<{
          'restaurant_id': string;
        }>;
      }> = {},
    ): Promise<IKitchen[]> {
      const response = await jsonApi.all('kitchen').get<IKitchen[]>(params);

      return response.data;
    },
  },
});

export default useKitchen;
